import Button from "./common/Button";

const CTA = () => {
	return (
		<section className="cta">
			<div className="container">
				<div className="cta-content">
					<h2>Ready to transform your business?</h2>
					<p>
						Contact us today to discuss how we can help you achieve your goals.
					</p>
					<Button to="/contact" variant="primary-light">
						Get Started
					</Button>
				</div>
			</div>
		</section>
	);
};

export default CTA;
